import { clearErrorClasses } from './helpers/validateInputsColor.js';

const validationLoginForm = () => {
    document.querySelectorAll('.auth_page .auth_input input[type="password"]').forEach((input) => {
        if (input.parentNode.querySelector('.auth_password_toggle')) return;
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'auth_password_toggle';
        toggle.setAttribute('aria-controls', input.id);
        const update = () => {
            const visible = input.type === 'text';
            toggle.setAttribute('aria-label', visible ? 'Ocultar contraseña' : 'Mostrar contraseña');
            toggle.setAttribute('aria-pressed', String(visible));
            toggle.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/>${visible ? '<path d="m3 3 18 18"/>' : ''}</svg>`;
        };
        update();
        toggle.addEventListener('click', () => {
            input.type = input.type === 'password' ? 'text' : 'password';
            update();
        });
        input.after(toggle);
    });
    const form = document.getElementById('login-form');
    if (!form) return;
    const username = document.getElementById('id_username');
    const password = document.getElementById('id_password');
    const error = document.getElementById('error_login_text');
    form.addEventListener('submit', (event) => {
        clearErrorClasses([username, password]);
        let invalid = null;
        let message = '';
        if (!username.value) {
            invalid = username;
            message = 'El campo usuario es obligatorio.';
        } else if (username.value.length < 4) {
            invalid = username;
            message = 'El usuario debe tener al menos 4 caracteres.';
        } else if (!password.value) {
            invalid = password;
            message = 'El campo contraseña es obligatorio.';
        }
        error.textContent = message;
        if (invalid) {
            event.preventDefault();
            invalid.classList.add('border-danger');
            invalid.focus();
        }
    });
};
export default validationLoginForm;
